import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyNo = () => {
    return <SupportPrivacyPolicy languageCode="no" />
}

export default SupportPrivacyPolicyNo
